import { render, staticRenderFns } from "./ViewSupplementsItem.vue?vue&type=template&id=2181acf2&scoped=true"
import script from "./ViewSupplementsItem.vue?vue&type=script&lang=js"
export * from "./ViewSupplementsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181acf2",
  null
  
)

export default component.exports